<template>
  <div class="m-up-box">
    <div class="m-bg-card">
      <img v-if="file.content" class="m-img" :src="file.content" alt="" @click="goLook(file.content)">
      <img v-else="" class="m-bg" src="@/assets/img/home/bgok.png" alt="">
    </div>
    <!--失败-->
    <div v-if="isUpKey==2" class="m-des">
      <p class="m-p">
        <van-icon class="m-ice" name="warning-o"/>
        <span> {{message}}</span></p>
      <p class="m-des-p m-p-bottom">失败存在以下几种原因：</p>
      <p class="m-des-p">1、注册姓名和身份证上的姓名不一致，请到个人中心【个人信息】修改。</p>
      <p class="m-des-p">2、注册时填写的身份证号有误，请使用正确的身份证号重新注册。</p>
      <p class="m-des-p">3、上传的身份证照片不清晰，或非本人身份证，请重新上传。</p>
    </div>
    <!--成功-->
    <div v-if="isUpKey==3" class="m-des-succee x-font-color">
      <van-icon style="font-weight: bold" name="passed"/>
      <span> 识别成功</span></div>
    <!--按钮、上传-->
    <van-uploader class="m-top-margin" :multiple="true" :max-count="1" :before-read="beforeRead"
                  :after-read="afterRead" accept="image/*">
      <van-button v-if="isUpKey==1" block class="x-btn-log m-btn-big">上传身份证</van-button>
      <van-button v-if="isUpKey==2" block class="x-btn-log m-btn-sm">重新上传</van-button>
      <div class="x-flex-between">
        <van-button v-if="isUpKey==3" block class="m-btn-default">重新上传</van-button>
        <van-button v-if="isUpKey==3" block class="x-btn-log m-btn-next" @click.stop="goTo()">下一步</van-button>
      </div>
    </van-uploader>
    <!--底部提示-->
    <div v-if="isUpKey==1" class="x-font-12">
      <p>1、上传身份证图片大小不超过4MB。</p>
      <p>2、所有上传照片需清晰且未遮挡，请勿进行美化和修改；</p>
      <p>3、所有上传信息均会被妥善保管，不会用于其他商业用途或传输给其他第三方；</p>
    </div>
    <van-image-preview v-model="show" :images="images"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    components: {},
    computed: {
      ...mapGetters({
        CONFIG_ITEM: 'enroll/configItem'
      })
    },
    data () {
      return {
        isUpKey: 1,
        show: false,
        file: {},
        images: [],
        message:''
      }
    },
    created () {

    },
    methods: {
//      onOversize (file) {
//        this.utils.toastNone('文件大小不能超过4MB')
//      },
      beforeRead(e){
        if(e.length>1){
          this.utils.toastError('只能选择一张图片上传！')
          return false
        }
        if(e.size>4194304){
          this.utils.toastError('文件大小不能超过4MB！')
          return false
        }
        return true
      },
      afterRead (e) {
//        alert(this.CONFIG_ITEM.id)
        this.file = e
        let msg = new FormData()
        msg.append('enrollId', this.CONFIG_ITEM.id);
        msg.append('imgBase64', e.content);
//        alert(this.CONFIG_ITEM.id)
        this.http.postRequest({
          headers: {'Content-Type': 'multipart/form-data'},
          url: 'app/faceAuth/authAndPhoto',
          msg: msg,
          special:true,
        },true).then((res)=>{
          this.$store.state.info.imgUrl = res.data ? res.data : ''
          if(res.code==500){
            this.isUpKey = 2
            this.message = res.msg
          }
          if(res.code==200){
            this.isUpKey = 3
          }
        },true)
      },
      goLook (i) {
        this.images = [i]
        this.show = true
      },
      goTo(){
        this.http.getRequest({
          url:`app/exam/findRegisterInfo/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            if(res.data&&res.data.register){
              if(res.data.register.recognizeType==1){
                this.$router.push({
                  path: '/livingFace',
                  query:this.$route.query
                })
              }else {
                this.$router.push({
                  path: '/face',
                  query:this.$route.query
                })
              }
            }
          }
        })
      },
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";

  .m-up-box {
    .m-bg-card {
      width: 300px;
      height: 180px;
      background: #F6F6F6;
      border-radius: 4px;
      padding: 10px 15px;
      .m-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .m-bg {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .m-des {
      text-align: center;
      font-size: 14px;
      padding-top: 5px;
      > p {
        line-height: 20px;
      }
      .m-p {
        color: #FB2927;
        .m-ice {
          font-weight: bold;
        }
      }
      .m-des-p{
        text-align: left;
      }
      .m-p-bottom{
        margin-top: 10px;
        margin-bottom: 10px;
        line-height: 15px;
      }
    }
    .m-top-margin {
      margin-top: 50px;
    }
    .m-des-succee {
      text-align: center;
      font-size: 14px;
      padding-top: 5px;
    }
    .m-btn {
      width: 132px;
    }
    .m-btn-big {
      width: 220px;
      margin: 0 auto;
    }
    .m-btn-sm {
      width: 132px;
      margin: 0 auto;
    }
    .x-font-12 {
      margin-top: 50px;
      > p {
        line-height: 18px;
      }
    }
    .x-flex-between {
      width: 300px;
      .m-btn-default, .m-btn-next {
        width: 132px;
      }
      .m-btn-default {
        border-radius: 4px;
        background: #F2F6FF;
        color: #2B6CF9;
      }
      .m-btn-next {
        z-index: 100;
      }
    }
  }
</style>

